// extracted by mini-css-extract-plugin
export default {"container":"shuffle-content_container__Uy8IC","tabs":"shuffle-content_tabs__ge6-v","content":"shuffle-content_content__EpXQy"};